
import { mapState, mapGetters } from 'vuex';

export default {
  i18nComponentKey: 'WidgetProductReviewsPhotoThumbnail.components.PhotoThumbnailProductScore',
  name: 'PhotoThumbnailProductScore',
  props: {
    totalReviewsCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('widget', ['device']),
    ...mapGetters('productScoreSummary', ['averageScoreText']),
    ...mapState('widget', ['isMobile']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('productScoreSummary', [
      'averageScore',
      'isLoadingScoreSummary'
    ]),
    score() {
      if (this.averageScoreText === null || this.averageScoreText === '0.0')
        return '-';
      return this.averageScoreText;
    },
    starSize() {
      return this.isMobile ? 10 : 12;
    }
  }
};
